const fn = {
    init: () => {
        const target = '#goog-gt-votingForm, #goog-gt-votingHiddenPane';
        const hideEl = (el) => {
            el.setAttribute('hidden', '');
            el.style.display = 'none';
            el.style.visibility = 'hidden';
        };
        const hideAll = () => {
            document.querySelectorAll(target).forEach(hideEl);
        };

        hideAll();

        const observer = new MutationObserver((mutations) => {
            let hit = false;
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType !== 1) return;
                    if (node.matches(target)) {
                        hideEl(node);
                        hit = true;
                    } else if (node.querySelectorAll(target).length) {
                        hit = true;
                    }
                });
            });
            if (hit) hideAll();
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });
    },
};

export default {
    can: () => true,
    run: fn.init,
};
